/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC1155PresetMinterPauser,
  ERC1155PresetMinterPauserInterface,
} from "../ERC1155PresetMinterPauser";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC1155PresetMinterPauserConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC1155PresetMinterPauserConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC1155PresetMinterPauser__factory extends ContractFactory {
  constructor(...args: ERC1155PresetMinterPauserConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC1155PresetMinterPauser> {
    return super.deploy(
      uri,
      overrides || {}
    ) as Promise<ERC1155PresetMinterPauser>;
  }
  getDeployTransaction(
    uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(uri, overrides || {});
  }
  attach(address: string): ERC1155PresetMinterPauser {
    return super.attach(address) as ERC1155PresetMinterPauser;
  }
  connect(signer: Signer): ERC1155PresetMinterPauser__factory {
    return super.connect(signer) as ERC1155PresetMinterPauser__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC1155PresetMinterPauserInterface {
    return new utils.Interface(_abi) as ERC1155PresetMinterPauserInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155PresetMinterPauser {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ERC1155PresetMinterPauser;
  }
}
